import axios from "../utils/axios";

export const getEquipmentReportList = () => {
    return axios.get(`EquipmentReportGroup/GetDetailedList`);
};

export const addEquipmentReport = (data) => {
    return axios.post(`/EquipmentReportGroup/Add`, data);
};

export const updateEquipmentReport = (data) => {
    return axios.post(`/EquipmentReportGroup/Update`, data);
};

export const deleteEquipmentReport = (payload) => {
    return axios.post(`/EquipmentReportGroup/Delete`, payload);
};

export const getPlants = () => {
    return axios.get(`/Plant/GetList`);
};